webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_eva_icons__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_eva_icons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_eva_icons__);

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_eva_icons___default.a);

var bus = new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]();

var defaultPlane = {
  id: 0,
  flightNumber: null,
  fuelled: false,
  boarded: 0,
  unboarding: false,
  requestedLanding: false,
  requestedTakeoff: false,
  takingOff: false,
  landing: false,
  atGate: false,
  schedule: null,
  passengerCapacity: 200,
  gateNumber: false,
  runway: false,
  position: {
    x: 0,
    y: 10
  }
};

var defaultSchedule = {
  requiresFuel: false,
  passengers: 200
};

var defaultGate = {
  gateNumber: 0,
  passengersPerTick: 4,
  staffed: false,
  permanentlyStaffed: false,
  autoApproveTakeoff: false
};

var defaultRunway = {
  runwayNumber: 0
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] },
  data: {
    gameTimer: null,
    gameOver: false,
    mainTick: 120,
    player: {
      planes: [],
      gates: [],
      runways: [],
      cash: 0,
      scheduled: []
    },
    airport: {
      open: true,
      takeoffQueue: [],
      runwayInUse: false,
      takeoffTimer: false,
      landingTimer: false
    },
    config: {
      landingTime: 4,
      tickSpeed: 1000,
      gameSpeed: 1,
      skipNight: true,
      sandboxMode: false,
      lastLandingSlot: 200
    },
    statistics: {
      totalPlanesArrived: 0,
      totalPlanesDeparted: 0,
      totalPassengersArrived: 0,
      totalPassengersDeparted: 0,
      cashHistory: []
    }
  },
  created: function created() {
    this.player.cash = 310050;
    // this.buyGate()
    // this.buyRunway()
    this.load();
    this.play();

    bus.$on('buy-plane', this.buyPlane);
    bus.$on('buy-gate', this.buyGate);
    bus.$on('buy-runway', this.buyRunway);
    bus.$on('buy-schedule', this.buySchedule);
    bus.$on('request-takeoff', this.requestTakeoff);
    bus.$on('plane-landed', this.planeLanded);
    bus.$on('staff-gate', this.staffGate);

    window.fbq('trackCustom', 'GameStart');
  },

  methods: {
    save: function save() {
      var game = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$data);
      window.localStorage.setItem('saveGame', game);
      bus.$emit('important', 'Game autosaved.');
    },
    load: function load() {
      var game = window.localStorage.getItem('saveGame');
      if (game) {
        var o = JSON.parse(game);
        for (var key in o) {
          this[key] = o[key];
        }
      }
    },
    play: function play() {
      var _this = this;

      this.gameTimer = setInterval(function () {
        _this.tick();
      }, this.config.tickSpeed / this.config.gameSpeed);
    },
    pause: function pause() {
      clearInterval(this.gameTimer);
    },
    tick: function tick() {
      this.statistics.cashHistory.unshift(this.player.cash);
      this.updateDay();
      this.checkLandings();
      this.checkTakeoffs();
      this.generateRandomLandings();
      bus.$emit('tick');
    },
    updateDay: function updateDay() {
      this.mainTick++;
      if (this.mainTick === 240) {
        this.mainTick = 0;

        // Terminal costs
        this.player.cash -= 7000;
        bus.$emit('notification', 'Terminal costs -7000');

        // Gate costs
        var gateCost = this.player.gates.length * 2000;
        this.player.cash -= gateCost;
        bus.$emit('notification', 'Gate costs ' + this.player.gates.length + ' X 2000 (-' + gateCost + ')');

        // Grounded plane costs
        var groundedPlaneCosts = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.player.planes, { atGate: true }).length * 2000;
        this.player.cash -= groundedPlaneCosts;
        bus.$emit('notification', 'Ground plane fine ' + this.player.planes.length + ' X 2000 (-' + groundedPlaneCosts + ')');
      }

      if (this.config.lastLandingSlot === this.mainTick) {
        bus.$emit('important', 'Arrivals closed. Departures are still open.');
      }

      if (this.mainTick === 200) {
        bus.$emit('important', 'The airport is closing soon, make sure the gates are empty to avoid fines.');
      }

      if (this.mainTick <= 60 || this.mainTick >= 220) {
        if (this.airport.open) {
          this.airport.open = false;
          document.body.style.background = '#161718';
          if (this.config.skipNight) {
            this.pause();
            this.config.gameSpeed = 12;
            this.play();
          }
          bus.$emit('important', 'The airport has now closed. All remaining passengers will be unboarded, runways are closed. Boardings will resume when the airport opens in the morning.');
        }
      } else {
        if (!this.airport.open) {
          this.airport.open = true;
          document.body.style.background = '#f3f6fb';
          this.pause();
          this.config.gameSpeed = 1;
          this.play();
          bus.$emit('important', 'The airport is now open. Boarding will begin shortly.');
          this.save();
        }
      }
    },
    generateRandomLandings: function generateRandomLandings() {
      if (!this.airport.open || this.mainTick > this.config.lastLandingSlot) {
        return false;
      }
      if (Math.random() < 0.3 && this.getAllPlanesInLandingQueue().length < this.player.gates.length) {
        var plane = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(defaultPlane);
        plane.landing = false;
        plane.flightNumber = this.generateFlightNumber();
        plane.requestedLanding = true;
        plane.unboarding = true;
        plane.boarded = 200;
        plane.id = parseInt(Math.random() * 100 * Math.random() / Math.random() * Math.random() * Math.random() * 1000000);
        this.player.planes.push(plane);
        bus.$emit('atc', 'Landing requested', plane.flightNumber, false);
        window.fbq('trackCustom', 'LandingRequested');
      }
    },
    findFreeGate: function findFreeGate() {
      var _this2 = this;

      var x = false;
      var gatesList = [];
      this.player.gates.forEach(function (gate) {
        if (!__WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(_this2.player.planes, { gateNumber: gate.gateNumber }) && gate.staffed) {
          gatesList.push(gate.gateNumber);
        }
      });
      console.log({ gatesList: gatesList });
      if (gatesList.length) {
        x = gatesList[Math.floor(Math.random() * gatesList.length)];
      }
      return x;
    },
    findFreeRunway: function findFreeRunway() {
      var _this3 = this;

      var x = false;
      var runwaysList = [];
      this.player.runways.forEach(function (runway) {
        console.log('checking runway ' + runway.runwayNumber);
        var planes = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(_this3.player.planes, { runway: runway.runwayNumber });
        if (!planes.length) {
          console.log('Runway free ' + runway.runwayNumber, planes);
          runwaysList.push(runway.runwayNumber);
        }
      });
      if (runwaysList.length) {
        x = runwaysList[Math.floor(Math.random() * runwaysList.length)];
      }
      return x;
    },
    buyGate: function buyGate() {
      if (this.player.gates.length >= 16 || this.player.cash < 50000) {
        return false;
      }
      console.log('buying gate');
      this.player.cash -= 50000;
      bus.$emit('important', 'Purchased gate -50000');
      var gate = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(defaultGate);
      gate.gateNumber = this.player.gates.length + 1;
      this.player.gates.push(gate);
      window.fbq('trackCustom', 'BuyGate');
    },
    buyRunway: function buyRunway() {
      if (this.player.runways.length >= 5 || this.player.cash < 250000) {
        return false;
      }
      console.log('buying runway');
      this.player.cash -= 250000;
      bus.$emit('important', 'Purchased runway -250000');
      var runway = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(defaultRunway);
      runway.runwayNumber = this.player.runways.length + 1;
      this.player.runways.push(runway);
      window.fbq('trackCustom', 'BuyRunway');
    },
    buyPlane: function buyPlane() {
      if (this.player.planes.length >= this.player.gates.length || this.player.cash < 10000) {
        return false;
      }
      this.player.cash -= 10000;
      bus.$emit('important', 'Purchased plane -10000');
      var plane = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.cloneDeep(defaultPlane);
      plane.gateNumber = this.findFreeGate();
      plane.id = parseInt(Math.random() * 100 * Math.random() / Math.random() * Math.random() * Math.random() * 1000000);
      this.player.planes.push(plane);
    },
    buySchedule: function buySchedule() {
      this.player.scheduled.push(defaultSchedule);
    },
    requestTakeoff: function requestTakeoff(plane) {
      this.airport.takeoffQueue.push(plane.id);
    },
    checkTakeoffs: function checkTakeoffs() {
      var _this4 = this;

      if (!this.airport.open) {
        return false;
      }

      // let queue = this.getAllPlanesInLandingQueue()

      if (this.findFreeRunway()) {
        var plane = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.player.planes, { requestedTakeoff: true });
        if (plane) {
          this.unstaffGate(plane.gateNumber);
          plane.requestedTakeoff = false;
          plane.atGate = false;
          plane.gateNumber = false;
          plane.runway = this.findFreeRunway();
          plane.takingOff = true;
          bus.$emit('atc', 'Takeoff approved. Use runway ' + plane.runway, plane.flightNumber, true);
          window.fbq('trackCustom', 'PlaneTookOff');
          // Plane takeoff timer
          setTimeout(function () {
            var i = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(_this4.player.planes, { id: plane.id });
            _this4.$delete(_this4.player.planes, i);
            bus.$emit('notification', 'Runway usage (Takeoff) +1500');
            _this4.player.cash += 1500;
            _this4.statistics.totalPlanesDeparted++;
            _this4.statistics.totalPassengersDeparted += 200;
          }, 3500);
        }
      }
    },
    checkLandings: function checkLandings() {
      var _this5 = this;

      if (!this.airport.open || this.mainTick > this.config.lastLandingSlot) {
        // REMOVE ALL PLANES IN QUEUE WHEN CLOSED
        var planesToLand = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.player.planes, { requestedLanding: true });
        planesToLand.forEach(function (plane) {
          bus.$emit('atc', 'Landing denied', plane.flightNumber, true);
          var i = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.findIndex(_this5.player.planes, { id: plane.id });
          _this5.$delete(_this5.player.planes, i);
        });
        console.log('Planes trying to land', planesToLand.length);
      } else if (this.findFreeRunway() !== false) {
        var planes = this.getAllPlanesInLandingQueue();
        if (planes.length) {
          console.log('Planes waiting to land', planes.length);
          var plane = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.player.planes, { id: planes[0].id });
          var gate = this.findFreeGate();
          var runway = this.findFreeRunway();
          if (plane && !plane.runway && gate && runway) {
            console.log('free gate + runway for landing', gate, runway, plane);
            plane.gateNumber = gate;
            plane.runway = runway;
            plane.requestedLanding = false;
            plane.landing = true;
            bus.$emit('atc', 'Landing approved. Use runway ' + plane.runway + ' and gate ' + plane.gateNumber, plane.flightNumber, true);
            window.fbq('trackCustom', 'PlaneLanded');
            setTimeout(function () {
              plane.runway = false;
              plane.landing = false;
              plane.atGate = true;
              bus.$emit('notification', 'Runway usage (Landing) +1500');
              _this5.player.cash += 1500;
              _this5.statistics.totalPlanesArrived++;
              _this5.statistics.totalPassengersArrived += 200;
            }, 3500);
          }
        }
      }
    },
    planeLanded: function planeLanded(id) {
      // let i = _.findIndex(this.airport.landingQueue, id)
      // console.log('INDEX!!!', i)
      // this.$delete(this.airport.landingQueue, i)
      bus.$emit('notification', 'Runway usage (Landing) +1000');
      this.$root.player.cash += 1000;
      this.$root.statistics.totalPlanesArrived++;
      this.$root.statistics.totalPassengersArrived += 200;
    },
    getPlaneInLandingQueue: function getPlaneInLandingQueue() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.player.planes, { requestedLanding: true, runway: false, landing: false, atGate: false });
    },
    getAllPlanesInLandingQueue: function getAllPlanesInLandingQueue() {
      return __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(this.player.planes, { requestedLanding: true, runway: false, landing: false, atGate: false });
    },
    unstaffGate: function unstaffGate(x) {
      var gate = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.player.gates, { gateNumber: x });
      if (gate && !gate.permanentlyStaffed) {
        gate.staffed = false;
      }
    },
    staffGate: function staffGate(x) {
      var gate = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.find(this.player.gates, { gateNumber: x });
      gate.staffed = true;
      var price = gate.passengersPerTick * 100;
      this.player.cash -= price;
      bus.$emit('notification', 'Staff costs -' + price);
      window.fbq('trackCustom', 'StaffGate');
    },
    generateFlightNumber: function generateFlightNumber() {
      var r = Math.random().toString(36).substring(7).toUpperCase();
      return 'AIR' + r;
    }
  },
  watch: {
    'config.sandboxMode': function configSandboxMode() {
      if (this.config.sandboxMode) {
        this.player.cash = 100000000;
        window.fbq('trackCustom', 'SandboxMode');
      }
    },
    'player.cash': function playerCash(to, from) {
      if (this.player.cash <= 0) {
        this.gameOver = true;
        this.pause();
        window.fbq('trackCustom', 'GameOver');
      }

      if (this.player.cash < 10000 && from > 10000) {
        bus.$emit('important', 'Your cash is getting low!');
      }
    },
    'statistics.totalPlanesDeparted': function statisticsTotalPlanesDeparted() {
      var prize = 10000;
      if (this.statistics.totalPlanesDeparted === 5) {
        bus.$emit('achievement', '5 planes departed (+' + prize + ')!');
        this.player.cash += prize;
      } else if (this.statistics.totalPlanesDeparted === 50) {
        bus.$emit('achievement', '50 planes departed (+' + prize + ')!');
        this.player.cash += prize;
      } else if (this.statistics.totalPlanesDeparted === 500) {
        bus.$emit('achievement', '500 planes departed (+' + prize + ')!');
        this.player.cash += prize;
      } else if (this.statistics.totalPlanesDeparted === 500) {
        bus.$emit('achievement', '500 planes departed (+' + prize + ')!');
        this.player.cash += prize;
      } else if (this.statistics.totalPlanesDeparted === 1000) {
        bus.$emit('achievement', '1000 planes departed (+' + prize + ')!');
        this.player.cash += prize;
      }
    }
  }
});

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_board__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plane__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_statusBar__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_store__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_notifications__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_tutorial__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_settings__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_atc__ = __webpack_require__(49);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {
    Board: __WEBPACK_IMPORTED_MODULE_0__components_board__["a" /* default */],
    Plane: __WEBPACK_IMPORTED_MODULE_1__components_plane__["a" /* default */],
    StatusBar: __WEBPACK_IMPORTED_MODULE_2__components_statusBar__["a" /* default */],
    Store: __WEBPACK_IMPORTED_MODULE_3__components_store__["a" /* default */],
    Notifications: __WEBPACK_IMPORTED_MODULE_4__components_notifications__["a" /* default */],
    Tutorial: __WEBPACK_IMPORTED_MODULE_5__components_tutorial__["a" /* default */],
    Settings: __WEBPACK_IMPORTED_MODULE_6__components_settings__["a" /* default */],
    Atc: __WEBPACK_IMPORTED_MODULE_7__components_atc__["a" /* default */]
  },
  methods: {
    restart: function restart() {
      window.localStorage.removeItem('saveGame');
      location.reload();
    }
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_gate__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__main__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'board',
  components: {
    Gate: __WEBPACK_IMPORTED_MODULE_0__components_gate__["a" /* default */],
    bus: __WEBPACK_IMPORTED_MODULE_1__main__["bus"]
  },
  data: function data() {
    return {};
  },

  methods: {
    dispatchAllPlanes: function dispatchAllPlanes() {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('dispatch-all-planes');
    },
    staffAllGates: function staffAllGates() {
      __WEBPACK_IMPORTED_MODULE_1__main__["bus"].$emit('staff-all-gates');
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'gate',
  props: ['gate'],
  components: {
    bus: __WEBPACK_IMPORTED_MODULE_0__main__["bus"]
  },
  data: function data() {
    return {
      showMenu: false
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on('staff-all-gates', function () {
      _this.staffGate();
    });
  },

  computed: {
    getXPosition: function getXPosition() {
      var x = this.gate.gateNumber * 8 + '%';
      if (this.gate.gateNumber > 8) {
        x = (this.gate.gateNumber - 8) * 8 + '%';
      }
      return x;
    },
    getYPosition: function getYPosition() {
      var y = '16%';
      if (this.gate.gateNumber > 8) {
        y = '61%';
      }
      return y;
    },
    planesTillNextUpgrade: function planesTillNextUpgrade() {
      return Math.ceil(this.gate.passengersPerTick * 5 * this.gate.passengersPerTick);
    }
  },
  methods: {
    upgrade: function upgrade() {
      var price = this.planesTillNextUpgrade * 100;
      this.gate.passengersPerTick = this.gate.passengersPerTick * 1.2;
      this.$root.player.cash -= price;
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('notification', 'Upgraded gate -' + price);
      window.fbq('trackCustom', 'GateUpgraded');
    },
    staffGate: function staffGate() {
      if (!this.$root.airport.open || this.gate.staffed) {
        return false;
      }
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('staff-gate', this.gate.gateNumber);
    },
    addPermanentStaff: function addPermanentStaff() {
      this.gate.staffed = true;
      this.gate.permanentlyStaffed = true;
      var price = 10000;
      this.$root.player.cash -= price;
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('notification', 'Upgraded gate -' + price);
    },
    autoApproveTakeoff: function autoApproveTakeoff() {
      this.gate.autoApproveTakeoff = true;
      var price = 10000;
      this.$root.player.cash -= price;
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('notification', 'Upgraded gate -' + price);
    }
  }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'plane',
  props: ['plane'],
  components: {
    bus: __WEBPACK_IMPORTED_MODULE_0__main__["bus"]
  },
  data: function data() {
    return {
      gate: null,
      readyForTakeoff: false,
      isBottomRow: false,
      timer: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.plane.fuelled = true;
    // this.timer = setInterval(() => {
    //   this.tick()
    // }, 1000)
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on('dispatch-all-planes', function () {
      _this.requestTakeoff();
    });
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on('tick', function () {
      _this.tick();
    });
  },
  beforeDestroy: function beforeDestroy() {
    // clearInterval(this.timer)
  },

  computed: {
    planePositionX: function planePositionX() {
      if (this.plane.requestedLanding) {
        return '150%';
      } else if (this.plane.takingOff || this.plane.landing) {
        return 73 + this.plane.runway * 4 + '%';
      } else if (this.gate && this.gate.gateNumber > 8) {
        return 1 + (this.plane.gateNumber - 8) * 8 + '%';
      } else {
        return 1 + this.plane.gateNumber * 8 + '%';
      }
    },
    planePositionY: function planePositionY() {
      if (this.plane.landing || this.plane.takingOff) {
        return '11%';
      } else if (this.gate && this.gate.gateNumber > 8) {
        return '62%';
      } else {
        return '17%';
      }
    }
  },
  methods: {
    tick: function tick() {
      if (this.$root.config.gameSpeed === 0 || this.plane.takingOff || this.plane.requestedTakeoff || this.plane.landing || this.plane.requestedLanding || this.readyForTakeoff) {
        return false;
      } else if (this.plane.unboarding) {
        this.unboardPassenger();
      } else if (this.plane.fuelled && this.plane.boarded >= this.plane.passengerCapacity) {
        this.readyForTakeoff = true;
        if (this.gate && this.gate.autoApproveTakeoff) {
          this.requestTakeoff();
        }
      } else {
        this.boardPassenger();
      }
    },
    requestTakeoff: function requestTakeoff() {
      if (!this.readyForTakeoff) {
        return false;
      }
      this.readyForTakeoff = false;
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('atc', 'Takeoff requested', this.plane.flightNumber, false);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('notification', 'Passenger departures terminal costs (' + this.plane.passengerCapacity + ' X 10) +' + this.plane.passengerCapacity * 10);
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('request-takeoff', this.plane);
      this.plane.requestedTakeoff = true;
      window.fbq('trackCustom', 'TakeoffRequested');
    },
    boardPassenger: function boardPassenger(x) {
      // Dont do anything if the plane is moving
      if (this.$root.config.gameSpeed === 0 || !this.$root.airport.open || this.plane.takingOff || this.plane.requestedTakeoff || this.plane.landing || this.plane.requestedLanding || this.readyForTakeoff) {
        return false;
      }
      var amount = this.gate ? this.gate.passengersPerTick : 1;
      if (!isNaN(x)) {
        amount = x;
      }
      // Only board if there are empty spaces
      if (this.plane.boarded < this.plane.passengerCapacity) {
        this.$root.player.cash += amount * 10;
        this.plane.boarded = Math.min(this.plane.passengerCapacity, this.plane.boarded + amount);
      }
    },
    unboardPassenger: function unboardPassenger(x) {
      // Dont do anything if the plane is moving
      if (this.$root.config.gameSpeed === 0 || this.plane.takingOff || this.plane.requestedTakeoff || this.plane.landing || this.plane.requestedLanding || this.readyForTakeoff) {
        return false;
      }
      var amount = this.gate ? this.gate.passengersPerTick : 1;
      if (!isNaN(x)) {
        amount = x;
      }
      if (this.plane.boarded > 0) {
        this.$root.player.cash += amount * 10;
        this.plane.boarded = Math.max(0, this.plane.boarded - amount);
      } else {
        __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('notification', 'Passenger arrivals terminal costs (' + this.plane.passengerCapacity + ' X 10) +' + this.plane.passengerCapacity * 10);
        this.plane.unboarding = false;
      }
    },
    bump: function bump() {
      if (this.plane.unboarding) {
        this.unboardPassenger(6);
      } else {
        this.boardPassenger(6);
      }
    },
    cheat: function cheat() {
      if (this.plane.unboarding) {
        this.unboardPassenger(30);
      } else {
        this.boardPassenger(30);
      }
    }
  },
  watch: {
    'plane.gateNumber': function planeGateNumber() {
      var x = this.plane.gateNumber;
      if (x) {
        this.gate = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.find(this.$root.player.gates, { gateNumber: x });
        if (this.gate.gateNumber > 8) {
          this.isBottomRow = true;
        }
      }
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'status-bar',
  data: function data() {
    return {
      showCashflow: false
    };
  },
  mounted: function mounted() {},

  computed: {
    getTimeWidth: function getTimeWidth() {
      return Math.ceil(this.$root.mainTick / 240 * 100) + '%';
    },
    planesOnGround: function planesOnGround() {
      var total = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.$root.player.planes, { requestedLanding: false });
      if (total) {
        total = total.length;
      } else {
        total = 0;
      }
      return total;
    },
    getCash: function getCash() {
      return this.formatCash(this.$root.player.cash);
    },
    getLandings: function getLandings() {
      var total = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.$root.player.planes, { requestedLanding: true });
      if (total) {
        total = total.length;
      } else {
        total = 0;
      }
      return total;
    },
    getTakeoffs: function getTakeoffs() {
      var total = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.filter(this.$root.player.planes, { requestedTakeoff: true });
      if (total) {
        total = total.length;
      } else {
        total = 0;
      }
      return total;
    },
    historyGraph: function historyGraph() {
      var a = this.$root.statistics.cashHistory.slice(0, 200);
      return a.reverse();
    },
    getMaxCashflow: function getMaxCashflow() {
      if (this.showCashflow) {
        return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.max(this.historyGraph);
      } else {
        return false;
      }
    }
  },
  methods: {
    getHistoryHeight: function getHistoryHeight(item) {
      return 'height: ' + item / this.getMaxCashflow * 100 + '%';
    },
    setGameSpeed: function setGameSpeed(x) {
      this.$root.pause();
      this.$root.config.gameSpeed = x;
      if (x !== 0) {
        this.$root.play();
      }
    },
    formatCash: function formatCash(n) {
      return parseFloat(n).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'store',
  components: {
    bus: __WEBPACK_IMPORTED_MODULE_0__main__["bus"]
  },
  data: function data() {
    return {
      showMenu: false
    };
  },
  created: function created() {},

  methods: {
    buyPlane: function buyPlane() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('buy-plane');
    },
    buySchedule: function buySchedule() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('buy-schedule');
    },
    buyGate: function buyGate() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('buy-gate');
    },
    buyRunway: function buyRunway() {
      __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$emit('buy-runway');
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'notifications',
  components: {
    bus: __WEBPACK_IMPORTED_MODULE_0__main__["bus"]
  },
  data: function data() {
    return {
      showMenu: false,
      showAchievement: false,
      notifications: [],
      history: [],
      achievements: []
    };
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on('notification', function (data) {
      _this.createNotification(data, 'NORMAL');
    });

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on('important', function (data) {
      _this.createNotification(data, 'IMPORTANT');
    });

    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on('achievement', function (data) {
      _this.createAchievement(data);
    });
  },

  computed: {},
  methods: {
    createNotification: function createNotification(data, type) {
      var _this2 = this;

      var notification = {
        content: data,
        id: Math.random() * Math.random() * 10000 / Math.random() * Math.random(),
        type: type
      };
      this.history.unshift(notification);
      this.notifications.unshift(notification);
      setTimeout(function () {
        // this.notification = null
        var i = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.findIndex(_this2.notifications, { id: notification.id });
        _this2.$delete(_this2.notifications, i);
      }, 5000);
    },
    createAchievement: function createAchievement(data) {
      var achievement = {
        content: data,
        seen: false
      };
      this.achievements.push(achievement);
      this.showAchievement = true;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tutorial',
  props: ['tutorial'],
  components: {
    bus: __WEBPACK_IMPORTED_MODULE_0__main__["bus"]
  },
  data: function data() {
    return {
      visible: true,
      step: 1
    };
  },
  created: function created() {},

  methods: {
    startTutorial: function startTutorial() {
      this.step = 1;
      this.visible = true;
      window.fbq('trackCustom', 'StartTutorial');
    }
  }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'store',
  components: {
    bus: __WEBPACK_IMPORTED_MODULE_0__main__["bus"]
  },
  data: function data() {
    return {
      showMenu: false
    };
  },
  created: function created() {},

  methods: {
    restart: function restart() {
      window.localStorage.removeItem('saveGame');
      location.reload();
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__main__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'atc',
  components: {
    bus: __WEBPACK_IMPORTED_MODULE_0__main__["bus"]
  },
  data: function data() {
    return {
      showMenu: false,
      conversations: [],
      focused: false
    };
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_0__main__["bus"].$on('atc', this.createConversation);
  },

  computed: {
    groupedConversations: function groupedConversations() {
      return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.groupBy(this.conversations, 'flightNumber');
    }
  },
  methods: {
    createConversation: function createConversation(message, flightNumber, isAtc) {
      this.conversations.unshift({
        message: message,
        flightNumber: flightNumber,
        isAtc: isAtc,
        id: Math.floor(Math.random() * Math.random() * 1000 * Math.random() * 10000)
      });
    }
  }
});

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(4);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f24ae856_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(52);
function injectStyle (ssrContext) {
  __webpack_require__(22)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f24ae856_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_board_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf88eda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_board_vue__ = __webpack_require__(29);
function injectStyle (ssrContext) {
  __webpack_require__(25)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aaf88eda"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_board_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aaf88eda_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_board_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gate_vue__ = __webpack_require__(6);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2c9e3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gate_vue__ = __webpack_require__(28);
function injectStyle (ssrContext) {
  __webpack_require__(27)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f2c9e3e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f2c9e3e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"gate",class:{ 'gate-staffed': _vm.gate.staffed && _vm.$root.airport.open, 'gate-bottom': _vm.gate.gateNumber > 8 },style:({ left: _vm.getXPosition, top: _vm.getYPosition })},[_c('div',{staticClass:"menu-toggle",attrs:{"title":"Upgrade stand"},on:{"click":function($event){_vm.showMenu = !_vm.showMenu}}},[_c('eva-icon',{attrs:{"name":"arrowhead-up-outline","width":"18","height":"18"}})],1),_vm._v(" "),_c('div',{staticClass:"staff",style:(("animation-delay: " + (3 * Math.random()) + "s;"))}),_vm._v(" "),_c('div',{staticClass:"walkway",style:(("transition-delay: " + (2 * Math.random()) + "s;"))}),_vm._v(" "),_c('div',{staticClass:"number"},[_vm._v(_vm._s(_vm.gate.gateNumber))]),_vm._v(" "),(!_vm.gate.staffed && _vm.$root.airport.open)?_c('div',{staticClass:"info",attrs:{"title":"Needs staff!"},on:{"click":_vm.staffGate}},[_c('eva-icon',{attrs:{"name":"people-outline"}})],1):_vm._e()]),_vm._v(" "),(_vm.showMenu)?_c('div',{staticClass:"menu"},[_c('div',{staticClass:"menu-inner"},[_c('div',{staticClass:"text-faded",on:{"click":function($event){_vm.showMenu = false}}},[_vm._v("Close")]),_vm._v(" "),_c('h3',[_vm._v("Upgrade gate "+_vm._s(_vm.gate.gateNumber))]),_vm._v(" "),_c('h4',[_vm._v("Passengers boarded / unboarded per tick")]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.$root.statistics.totalPlanesDeparted < _vm.planesTillNextUpgrade && _vm.gate.passengersPerTick < 24),expression:"$root.statistics.totalPlanesDeparted < planesTillNextUpgrade && gate.passengersPerTick < 24"}],staticClass:"error"},[_vm._v("You need to dispatch a minimum of "+_vm._s(_vm.planesTillNextUpgrade)+" planes to unlock this.")]),_vm._v(" "),_c('button',{class:{ disabled: _vm.$root.statistics.totalPlanesDeparted < _vm.planesTillNextUpgrade && _vm.gate.passengersPerTick < 25 },on:{"click":_vm.upgrade}},[_vm._v("Upgrade "+_vm._s(Math.ceil(_vm.gate.passengersPerTick * 1.2))+" ($"+_vm._s(_vm.planesTillNextUpgrade * 100)+")")]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Permanently staff gate")]),_vm._v(" "),_c('p',[_vm._v("Each time a plane takesoff staff are automatically requested for the next flight.")]),_vm._v(" "),_c('button',{class:{ disabled: _vm.gate.permanentlyStaffed },on:{"click":_vm.addPermanentStaff}},[_vm._v("Add permanent staff (10,000)")])]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Auto approve takeoff")]),_vm._v(" "),_c('p',[_vm._v("When the plane is fully boarded the plane will automatically request takeoff.")]),_vm._v(" "),_c('button',{class:{ disabled: _vm.gate.autoApproveTakeoff },on:{"click":_vm.autoApproveTakeoff}},[_vm._v("Auto approve takeoff (10,000)")])]),_vm._v(" "),_c('div',{staticClass:"text-faded",on:{"click":function($event){_vm.showMenu = false}}},[_vm._v("Close")])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"board",class:{ paused: _vm.$root.config.gameSpeed === 0, fast: _vm.$root.config.gameSpeed === 6 }},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.$root.player.runways),function(runway){return _c('div',{key:runway.runwayNumber,staticClass:"runway",style:({ left: 74 + (runway.runwayNumber * 4) + '%' })},[_vm._v(_vm._s(runway.runwayNumber))])}),_vm._v(" "),_c('div',{staticClass:"gates"},_vm._l((_vm.$root.player.gates),function(gate){return _c('gate',{key:gate.gateNumber,attrs:{"gate":gate}})}),1),_vm._v(" "),_c('div',{staticClass:"terminal"},[_c('button',{class:{ disabled: !_vm.$root.airport.open},on:{"click":_vm.staffAllGates}},[_c('eva-icon',{attrs:{"name":"people-outline"}}),_vm._v(" Staff all gates")],1),_vm._v(" "),_c('button',{class:{ disabled: !_vm.$root.airport.open},on:{"click":_vm.dispatchAllPlanes}},[_c('eva-icon',{attrs:{"name":"done-all-outline"}}),_vm._v(" Accept all takeoff requests")],1),_vm._v(" "),_c('div',{staticClass:"fan left"}),_vm._v(" "),_c('div',{staticClass:"fan right"})]),_vm._v(" "),_c('div',{staticClass:"taxiways"}),_vm._v(" "),_c('div',{staticClass:"road"}),_vm._v(" "),_vm._m(0)],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forests"},[_c('div',{staticClass:"forest"}),_vm._v(" "),_c('div',{staticClass:"forest"}),_vm._v(" "),_c('div',{staticClass:"forest"}),_vm._v(" "),_c('div',{staticClass:"forest"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_plane_vue__ = __webpack_require__(7);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5f1704_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plane_vue__ = __webpack_require__(33);
function injectStyle (ssrContext) {
  __webpack_require__(31)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a5f1704"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_plane_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a5f1704_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_plane_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plane",class:{ 'bottom-row': _vm.isBottomRow, 'taking-off': _vm.plane.takingOff, fuelled: _vm.plane.fuelled, landing: _vm.plane.landing, unboarding: _vm.plane.unboarding },style:({ top: _vm.planePositionY, left: _vm.planePositionX }),on:{"click":[_vm.bump,function($event){if(!$event.shiftKey){ return null; }return _vm.cheat($event)}]}},[_c('div',{staticClass:"plane-img",class:{ 'at-gate': _vm.plane.atGate }}),_vm._v(" "),(!_vm.$root.airport.open)?_c('div',{staticClass:"sign error",attrs:{"title":"Plane grounded untill morning"}},[_c('eva-icon',{attrs:{"name":"radio-outline","width":"18","height":"18"}}),_vm._v(" "),_c('eva-icon',{attrs:{"name":"alert-triangle-outline","width":"18","height":"18"}})],1):(_vm.readyForTakeoff)?_c('div',{staticClass:"sign takeoff",class:{ disabled: !_vm.$root.airport.open },attrs:{"title":"Ready for takeoff"},on:{"click":_vm.requestTakeoff}},[_c('eva-icon',{attrs:{"name":"checkmark-outline","width":"18","height":"18"}})],1):(_vm.plane.unboarding)?_c('div',{staticClass:"sign info",attrs:{"title":"Passengers unboarding"}},[_c('eva-icon',{attrs:{"name":"arrow-downward","width":"18","height":"18"}}),_vm._v(" "+_vm._s(_vm.plane.boarded))],1):(_vm.plane.requestedTakeoff)?_c('div',{staticClass:"sign waiting",attrs:{"title":"Waiting for takeoff slot"}},[_c('eva-icon',{attrs:{"name":"clock-outline","width":"18","height":"18"}})],1):(!_vm.plane.takingOff)?_c('div',{staticClass:"sign info",attrs:{"title":"Passengers boarding"}},[_c('eva-icon',{attrs:{"name":"arrow-upward","width":"18","height":"18"}}),_vm._v(" "+_vm._s(200 - _vm.plane.boarded))],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_statusBar_vue__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56df3007_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_statusBar_vue__ = __webpack_require__(36);
function injectStyle (ssrContext) {
  __webpack_require__(35)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-56df3007"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_statusBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56df3007_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_statusBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"status-bar-wrapper"},[_c('div',{staticClass:"status-bar"},[_c('div',{staticClass:"status-bar-item time",class:{ sunset: _vm.$root.mainTick >= 170 || _vm.$root.mainTick <= 90 },attrs:{"title":"Airport open/closed"}},[(_vm.$root.airport.open)?_c('eva-icon',{class:{ spin: _vm.$root.config.gameSpeed === 6, sun: _vm.$root.config.gameSpeed !== 0 },attrs:{"name":"sun-outline"}}):_c('eva-icon',{attrs:{"name":"moon-outline"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(Math.floor(_vm.$root.mainTick / 10))+":00")]),_vm._v(" "),_c('div',{staticClass:"time-inner",style:({ width: _vm.getTimeWidth })})],1),_vm._v(" "),_c('div',{staticClass:"status-bar-item clickable",class:{ warning: _vm.$root.player.cash < 10000 },attrs:{"title":"Balance"},on:{"click":function($event){_vm.showCashflow = !_vm.showCashflow}}},[_c('eva-icon',{attrs:{"name":"credit-card-outline"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getCash))])],1),_vm._v(" "),_c('div',{staticClass:"status-bar-item",class:{ closed: !_vm.$root.airport.open },attrs:{"title":"Waiting to takeoff"}},[_c('eva-icon',{attrs:{"name":"diagonal-arrow-right-up-outline"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getTakeoffs))])],1),_vm._v(" "),_c('div',{staticClass:"status-bar-item",class:{ closed: _vm.$root.mainTick >= _vm.$root.config.lastLandingSlot || !_vm.$root.airport.open },attrs:{"title":"Waiting to land"}},[_c('eva-icon',{attrs:{"name":"diagonal-arrow-right-down-outline"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getLandings))])],1),_vm._v(" "),_c('div',{staticClass:"status-bar-item clickable",class:{ paused: _vm.$root.config.gameSpeed === 0, 'super-speed': _vm.$root.config.gameSpeed === 12  },attrs:{"title":"Normal / Fast / Pause"}},[(_vm.$root.config.gameSpeed === 1)?_c('eva-icon',{attrs:{"name":"arrow-ios-forward-outline"},on:{"click":function($event){return _vm.setGameSpeed(6)}}}):(_vm.$root.config.gameSpeed === 6)?_c('eva-icon',{attrs:{"name":"arrowhead-right"},on:{"click":function($event){return _vm.setGameSpeed(0)}}}):(_vm.$root.config.gameSpeed === 12)?_c('eva-icon',{attrs:{"name":"arrowhead-right"},on:{"click":function($event){return _vm.setGameSpeed(0)}}}):_c('eva-icon',{attrs:{"name":"pause-circle-outline"},on:{"click":function($event){return _vm.setGameSpeed(1)}}})],1)])]),_vm._v(" "),(_vm.showCashflow)?_c('div',{staticClass:"cashflow"},[_c('h2',[_vm._v("Cash flow")]),_vm._v(" "),_c('div',{staticClass:"cash-history"},_vm._l((_vm.historyGraph),function(item,i){return _c('div',{key:item * i + i,staticClass:"history-item",style:(_vm.getHistoryHeight(item)),attrs:{"title":_vm.formatCash(item)}})}),0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Flight & passengers")]),_vm._v(" "),_c('table',_vm._l((_vm.$root.statistics),function(value,key){return (key !== 'cashHistory')?_c('tr',[_c('td',[_vm._v(_vm._s(key))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(value))])]):_vm._e()}),0)]),_vm._v(" "),_c('div',{staticClass:"col"},[_c('h3',[_vm._v("Daily costs")]),_vm._v(" "),_c('table',[_vm._m(0),_vm._v(" "),_c('tr',[_c('td',[_vm._v("Gates")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(this.$root.player.gates.length * 2000))])])])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_vm._v("Terminal")]),_vm._v(" "),_c('td',[_vm._v("-7000")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_store_vue__ = __webpack_require__(9);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9614ca3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_store_vue__ = __webpack_require__(39);
function injectStyle (ssrContext) {
  __webpack_require__(38)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9614ca3a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_store_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9614ca3a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_store_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ open: _vm.showMenu }},[_c('div',{staticClass:"store-toggle toggle",attrs:{"title":"Open store"},on:{"click":function($event){_vm.showMenu = !_vm.showMenu}}},[_c('eva-icon',{attrs:{"name":"shopping-cart-outline"}})],1),_vm._v(" "),(_vm.showMenu)?_c('div',{staticClass:"store"},[_c('div',{staticClass:"store-inner"},[_c('h3',[_vm._v("Store")]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Gate")]),_vm._v(" "),_c('p',[_vm._v("Gates receive passengers & planes. They require staff.")]),_vm._v(" "),_c('button',{class:{ disabled: _vm.$root.player.gates.length === 16 || _vm.$root.player.cash < 50000 || !_vm.$root.player.runways.length },on:{"click":_vm.buyGate}},[_c('eva-icon',{attrs:{"name":"upload-outline"}}),_vm._v(" Build gate ($50,000)")],1)]),_vm._v(" "),_c('div',[_c('h4',[_vm._v("Runway")]),_vm._v(" "),_c('p',[_vm._v("Runways allow planes to land and takeoff.")]),_vm._v(" "),_c('button',{class:{ disabled: _vm.$root.player.runways.length === 5 || _vm.$root.player.cash < 250000 },on:{"click":_vm.buyRunway}},[_c('eva-icon',{attrs:{"name":"arrowhead-up-outline"}}),_vm._v(" Build runway ($250,000)")],1)])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__ = __webpack_require__(10);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55719776_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__ = __webpack_require__(42);
function injectStyle (ssrContext) {
  __webpack_require__(41)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-55719776"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_notifications_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55719776_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_notifications_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 41 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ open: _vm.showMenu }},[_c('div',{staticClass:"notifications-toggle toggle",attrs:{"title":"History"},on:{"click":function($event){_vm.showMenu = !_vm.showMenu}}},[_c('eva-icon',{attrs:{"name":"bell-outline"}})],1),_vm._v(" "),(_vm.showMenu)?_c('div',{staticClass:"notifications"},[_c('h3',[_vm._v("History")]),_vm._v(" "),_vm._l((_vm.history),function(item,i){return _c('div',{key:i,staticClass:"notification-history",class:{ error: item.type === 'IMPORTANT' }},[_vm._v("\n      "+_vm._s(item.content)+"\n    ")])})],2):_vm._e(),_vm._v(" "),(_vm.notifications.length || _vm.showAchievement)?_c('div',{staticClass:"live-feed"},[_vm._l((_vm.achievements),function(item){return (!item.seen)?_c('div',{key:item.content,staticClass:"achievement"},[_c('eva-icon',{attrs:{"name":"star","width":100,"height":100}}),_vm._v(" "),_c('h2',[_vm._v(_vm._s(item.content))]),_vm._v(" "),_c('button',{on:{"click":function($event){item.seen = true}}},[_vm._v("Dismiss")])],1):_vm._e()}),_vm._v(" "),_vm._l((_vm.notifications),function(notification,i){return (notification.type === 'IMPORTANT')?_c('div',{key:notification.id,staticClass:"notification",class:{ error: notification.type === 'IMPORTANT' }},[_vm._v("\n      "+_vm._s(notification.content)+"\n    ")]):_vm._e()})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tutorial_vue__ = __webpack_require__(11);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc488a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tutorial_vue__ = __webpack_require__(45);
function injectStyle (ssrContext) {
  __webpack_require__(44)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1bc488a4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tutorial_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bc488a4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_tutorial_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"toggle toggle-help",on:{"click":_vm.startTutorial}},[_c('eva-icon',{attrs:{"name":"question-mark-outline"}})],1),_vm._v(" "),(_vm.visible)?_c('div',{staticClass:"tutorial"},[(_vm.step === 1)?_c('div',{staticClass:"tutorial-card"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/plane.jpg","alt":""}}),_vm._v(" "),_c('h2',[_vm._v("Welcome to Airport")]),_vm._v(" "),_c('p',[_vm._v("Buy gates & runways, manage planes, stay out of debt.")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step = 2}}},[_vm._v("Next - Expanding your airport")])]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('div',{staticClass:"tutorial-card"},[_c('eva-icon',{attrs:{"name":"shopping-cart-outline","width":40,"height":40}}),_vm._v(" "),_c('h2',[_vm._v("Expanding your aiport")]),_vm._v(" "),_c('p',[_vm._v("On the bottom right use the shopping cart to buy items.")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step--}}},[_vm._v("Back")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step = 3}}},[_vm._v("Next - What's going on?")])],1):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('div',{staticClass:"tutorial-card"},[_c('eva-icon',{attrs:{"name":"bell-outline","width":40,"height":40}}),_vm._v(" "),_c('h2',[_vm._v("What's going on?")]),_vm._v(" "),_c('p',[_vm._v("On the top right use the bell to view what's been happening.")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step--}}},[_vm._v("Back")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step = 4}}},[_vm._v("Next - Ssssshh!")])],1):_vm._e(),_vm._v(" "),(_vm.step === 4)?_c('div',{staticClass:"tutorial-card"},[_c('eva-icon',{attrs:{"name":"moon-outline","width":40,"height":40}}),_vm._v(" "),_c('h2',[_vm._v("Sssssshhh!")]),_vm._v(" "),_c('p',[_vm._v("The airport closes at 22:00 and re-opens at 6:00. You'll be fined for each plane that's at a gate. All runways are closed.")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step--}}},[_vm._v("Back")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step = 5}}},[_vm._v("Next - Attention please!")])],1):_vm._e(),_vm._v(" "),(_vm.step === 5)?_c('div',{staticClass:"tutorial-card"},[_c('eva-icon',{attrs:{"name":"people-outline","width":40,"height":40}}),_vm._v(" "),_c('h2',[_vm._v("Attention please!")]),_vm._v(" "),_c('p',[_vm._v("Gates need staff to accept planes and passengers.")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step--}}},[_vm._v("Back")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step = 6}}},[_vm._v("Next - Hurry up!")])],1):_vm._e(),_vm._v(" "),(_vm.step === 6)?_c('div',{staticClass:"tutorial-card"},[_c('eva-icon',{attrs:{"name":"arrow-forward-outline","width":40,"height":40}}),_vm._v(" "),_c('h2',[_vm._v("Hurry up!")]),_vm._v(" "),_c('p',[_vm._v("Spam click on planes to hurry up passengers.")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.step--}}},[_vm._v("Back")]),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.visible = false}}},[_vm._v("Finish")])],1):_vm._e(),_vm._v(" "),_c('button',{on:{"click":function($event){_vm.visible = false}}},[_vm._v("Close tutorial")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__ = __webpack_require__(12);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d329c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__(48);
function injectStyle (ssrContext) {
  __webpack_require__(47)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-57d329c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57d329c0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 47 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ open: _vm.showMenu }},[_c('div',{staticClass:"settings-toggle toggle",attrs:{"title":"Open store"},on:{"click":function($event){_vm.showMenu = !_vm.showMenu}}},[_c('eva-icon',{attrs:{"name":"settings-outline"}})],1),_vm._v(" "),(_vm.showMenu)?_c('div',{staticClass:"settings"},[_c('div',{staticClass:"settings-inner"},[_c('h2',[_vm._v("Options")]),_vm._v(" "),_c('div',[_c('button',{on:{"click":_vm.restart}},[_vm._v("Restart game")]),_vm._v(" "),_c('button',{on:{"click":_vm.$root.save}},[_vm._v("Save game")]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/Lewitje/Airplane-game","target":"_blank"}},[_vm._v("Github")])]),_vm._v(" "),_c('label',{staticClass:"range",class:{ disabled: _vm.$root.config.sandboxMode }},[_c('span',{staticClass:"title"},[_vm._v("Last landing time")]),_vm._v(" "),_c('div',{staticClass:"range-bar"},[_c('div',{staticClass:"range-btn",class:{ disabled: _vm.$root.config.lastLandingSlot === 180 },on:{"click":function($event){_vm.$root.config.lastLandingSlot -= 10}}},[_c('eva-icon',{attrs:{"name":"minus-outline"}})],1),_vm._v(" "),_c('div',{staticClass:"range-value"},[_vm._v("\n            "+_vm._s(_vm.$root.config.lastLandingSlot / 10)+":00\n          ")]),_vm._v(" "),_c('div',{staticClass:"range-btn",class:{ disabled: _vm.$root.config.lastLandingSlot === 220 },on:{"click":function($event){_vm.$root.config.lastLandingSlot += 10}}},[_c('eva-icon',{attrs:{"name":"plus-outline"}})],1)]),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s((220 - _vm.$root.config.lastLandingSlot) / 10)+" hours")]),_vm._v(" before closure")]),_c('br'),_vm._v(" "),_c('p',[_vm._v("No planes may land after this time. (helps with automated gates & fines)")])]),_vm._v(" "),_c('label',{staticClass:"checkbox"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.config.skipNight),expression:"$root.config.skipNight"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.$root.config.skipNight)?_vm._i(_vm.$root.config.skipNight,null)>-1:(_vm.$root.config.skipNight)},on:{"change":function($event){var $$a=_vm.$root.config.skipNight,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.$root.config, "skipNight", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.$root.config, "skipNight", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.$root.config, "skipNight", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Skip through night")]),_vm._v(" "),_c('p',[_vm._v("Super speed through the night.")])]),_vm._v(" "),_c('label',{staticClass:"checkbox",class:{ disabled: _vm.$root.config.sandboxMode }},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.$root.config.sandboxMode),expression:"$root.config.sandboxMode"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.$root.config.sandboxMode)?_vm._i(_vm.$root.config.sandboxMode,null)>-1:(_vm.$root.config.sandboxMode)},on:{"change":function($event){var $$a=_vm.$root.config.sandboxMode,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.$root.config, "sandboxMode", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.$root.config, "sandboxMode", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.$root.config, "sandboxMode", $$c)}}}}),_vm._v(" "),_c('span',[_vm._v("Sandbox mode")]),_vm._v(" "),_c('p',[_vm._v("Lots of money (Cannot be undone).")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atc_vue__ = __webpack_require__(13);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228a1284_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_atc_vue__ = __webpack_require__(51);
function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-228a1284"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_atc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_228a1284_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_atc_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ open: _vm.showMenu }},[_c('div',{staticClass:"atc",on:{"click":function($event){_vm.showMenu = !_vm.showMenu}}},[_vm._v("ATC")]),_vm._v(" "),(_vm.showMenu)?_c('div',{staticClass:"menu"},[_c('div',{staticClass:"menu-inner"},[_c('div',{staticClass:"text-faded",on:{"click":function($event){_vm.showMenu = false}}},[_vm._v("Close ATC")]),_vm._v(" "),_c('h2',[_vm._v("ATC")]),_vm._v(" "),(!_vm.$root.airport.open)?_c('p',{staticClass:"error"},[_c('b',[_vm._v("Airport closed")])]):(_vm.$root.config.lastLandingSlot - _vm.$root.mainTick > 0)?_c('p',[_c('b',[_vm._v("Open for "+_vm._s((_vm.$root.config.lastLandingSlot - _vm.$root.mainTick) / 10)+" hours")])]):_c('p',[_c('b',{staticClass:"error"},[_vm._v("Arrivals closed.")]),_c('br'),_vm._v("Departures open for "+_vm._s((220 - _vm.$root.mainTick) / 10)+" hours")]),_vm._v(" "),_vm._l((_vm.groupedConversations),function(flight,key,i){return (i < 40)?_c('div',{staticClass:"flight"},[_c('h4',[_vm._v("Flight "+_vm._s(key))]),_vm._v(" "),_vm._l((flight),function(item){return _c('div',{staticClass:"message",class:{ 'response': item.isAtc }},[_c('p',[_vm._v(_vm._s(item.message))])])})],2):_vm._e()})],2)]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'airport-closed': !_vm.$root.airport.open },attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('tutorial'),_vm._v(" "),_c('main',[_c('settings'),_vm._v(" "),_c('notifications'),_vm._v(" "),(_vm.$root.gameOver)?_c('div',{staticClass:"game-over"},[_c('h1',[_vm._v("Game Over")]),_vm._v(" "),_c('p',[_vm._v("You went bankrupt")]),_vm._v(" "),_c('button',{on:{"click":_vm.restart}},[_vm._v("Restart")])]):_c('board',_vm._l((_vm.$root.player.planes),function(plane){return _c('plane',{key:plane.id,attrs:{"plane":plane}})}),1),_vm._v(" "),_c('status-bar'),_vm._v(" "),_c('store'),_vm._v(" "),_c('atc')],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screen-too-small"},[_c('img',{staticClass:"logo",attrs:{"src":"/static/img/plane.jpg","alt":""}}),_vm._v(" "),_c('h1',[_vm._v("Airport")]),_vm._v(" "),_c('p',[_vm._v("A game where you manage an airport.")]),_vm._v(" "),_c('p',{staticClass:"text-faded"},[_vm._v("Rotate your phone to continue.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
],[1]);


// WEBPACK FOOTER //
// static/js/app.dacac319e29e614c81b3.js